import {Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import { DefaultLanguage } from '@shared/constants/constants';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { ContentMediaType } from '@shared/enums/ContentMediaType';
import { IAdvancedTemplateModel } from '@shared/services/api/dashboard/advanced-templates-service/advanced-templates.model';
import { StyleService } from '@shared/services/style/style.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-advanced-template-view',
    templateUrl: './advanced-template-view.component.html',
    styleUrls: ['./advanced-template-view.component.scss'],
})
export class AdvancedTemplateViewComponent {

    public ContentContextType = ContentContextType;
    public ContentMediaType = ContentMediaType;

    @ViewChild('bannerBlock')
    public bannerBlock: ElementRef;

    constructor(
        public styleService: StyleService
    ) { }

    @Input()
    get model(): IAdvancedTemplateModel { return this.model$.value; }
    set model(value: IAdvancedTemplateModel) { this.model$.next(value); }
    public model$: BehaviorSubject<IAdvancedTemplateModel> = new BehaviorSubject<IAdvancedTemplateModel>(undefined);

    @Input()
    get language(): string { return this.language$.value; }
    set language(value: string) { this.language$.next(value); }
    public language$: BehaviorSubject<string> = new BehaviorSubject<string>(DefaultLanguage);

    @Input()
    get contentContextType(): ContentContextType { return this.contentContextType$.value; }
    set contentContextType(value: ContentContextType) { this.contentContextType$.next(value); }
    public contentContextType$: BehaviorSubject<ContentContextType> = new BehaviorSubject<ContentContextType>(ContentContextType.Email);

    @Input()
    get mediaTypePage(): ContentMediaType { return this.mediaTypePage$.value; }
    set mediaTypePage(value: ContentMediaType) { this.mediaTypePage$.next(value); }
    public mediaTypePage$: BehaviorSubject<ContentMediaType> = new BehaviorSubject<ContentMediaType>(undefined);

    @Input()
    get mediaTypeEmail(): ContentMediaType { return this.mediaTypeEmail$.value; }
    set mediaTypeEmail(value: ContentMediaType) { this.mediaTypeEmail$.next(value); }
    public mediaTypeEmail$: BehaviorSubject<ContentMediaType> = new BehaviorSubject<ContentMediaType>(undefined);

    @Input()
    get useContentPage(): boolean { return this.useContentPage$.value; }
    set useContentPage(value: boolean) { this.useContentPage$.next(value); }
    public useContentPage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    @Input()
    get useContentEmail(): boolean { return this.useContentEmail$.value; }
    set useContentEmail(value: boolean) { this.useContentEmail$.next(value); }
    public useContentEmail$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    @HostListener('window:resize', ['$event'])
    public contentTopMargin(): string {
        let margin = 0;
        if (!this.model.contentSetting.isBelowBanner && this.bannerBlock) {
            margin = this.bannerBlock.nativeElement.offsetHeight * -1;
        }
        return `calc(${margin}px + ${this.model.contentSetting.marginTop}%)`;
    }
}
